import { planInputType } from 'constants/business-plan.constants';

export const preparePlanData = (businessPlans: any, t: any) => {
	const data = businessPlans.map((item: any) => {
		return [
			{
				fieldName: `${t('page.businessPlans.plans.table.headers.conversionPercentage')}`,
				planPointer: 'pipsPercent',
				idPointer: item?.id,
				inputValue: item?.pipsPercent?.toString() || '0',
				type: planInputType.NUMBER,
				sign: '%',
			},
			{
				fieldName: `${t('page.businessPlans.plans.table.headers.monthlyPay')}`,
				planPointer: 'monthlyFeeAmount',
				idPointer: item?.id,
				inputValue: item?.monthlyFeeAmount?.toString() || '0',
				type: planInputType.NUMBER,
				sign: '$',
			},
			{
				fieldName: `${t('page.businessPlans.plans.table.headers.swiftSHA')}`,
				planPointer: 'shared',
				idPointer: item?.id,
				inputValue: item?.shared?.toString() || '0',
				type: planInputType.NUMBER,
				sign: '$',
			},
			{
				fieldName: `${t('page.businessPlans.plans.table.headers.swiftOUR')}`,
				planPointer: 'ours',
				idPointer: item?.id,
				inputValue: item?.ours?.toString() || '0',
				type: planInputType.NUMBER,
				sign: '$',
			},
			{
				fieldName: `${t('page.businessPlans.plans.table.headers.local')}`,
				planPointer: 'local',
				idPointer: item?.id,
				inputValue: item?.local?.toString() || '0',
				type: planInputType.NUMBER,
				sign: '$',
			},
			{
				fieldName: `${t('page.businessPlans.plans.table.headers.hyperCode')}`,
				disabled: true,
				planPointer: 'hyperCode',
				idPointer: item?.id,
				inputValue: item?.hyperCode?.toString() || '',
				type: planInputType.CODE,
				sign: '',
			},
		];
	});
	return data;
};
